import { render, staticRenderFns } from "./SectionCheckDocuments.vue?vue&type=template&id=468a9ca9&scoped=true&"
import script from "./SectionCheckDocuments.vue?vue&type=script&lang=ts&"
export * from "./SectionCheckDocuments.vue?vue&type=script&lang=ts&"
import style0 from "./SectionCheckDocuments.vue?vue&type=style&index=0&id=468a9ca9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468a9ca9",
  null
  
)

export default component.exports